<ciciam-frame-front>
  <div class="w-full md:max-w-md md:mt-0 xl:p-0 md:ml-auto">
    <div class="py-6 md:p-6">
      <h2 class="text-xl text-green-800 font-semibold">
        {{ 'Forgot Username' | translate }}
      </h2>

      <div class="py-2"></div>

      <ciciam-form-forgot-username
        *ngIf="!(userInfo.email || userInfo.mobilePhone)"
        #forgotUsernameForm
        [isLoading]="isLoading"
        (forgotUsername)="forgotUsername($event)"
      ></ciciam-form-forgot-username>

      <ng-container *ngIf="userInfo.email || userInfo.mobilePhone">
        <!-- <p
          class="mb-4 text-sm font-light text-gray-800 dark:text-gray-400 text-start"
        >
          <a
            (click)="resetForm()"
            class="text-notus-primary-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
            >{{ 'Back' | translate }}</a
          >
        </p> -->

        <div class="relative rounded-3xl border border-gray-300 p-4">
          <p
            class="text-sm font-light text-gray-800 dark:text-white text-justify"
          >
            <span>{{ 'Your username will be sent to' | translate }}</span>
            <span *ngIf="userInfo.mobilePhone" class="font-medium text-black">{{
              'Phone number' | translate
            }}</span>
            <span
              *ngIf="!userInfo.mobilePhone && userInfo.email"
              class="font-medium text-black"
              >{{ 'Email Address' | translate }}</span
            >
          </p>

          <p
            *ngIf="userInfo.mobilePhone"
            class="text-sm font-medium text-black"
          >
            {{ userInfo.mobilePhone }}
          </p>

          <p
            *ngIf="!userInfo.mobilePhone && userInfo.email"
            class="text-sm font-medium text-black"
          >
            {{ userInfo.email }}
          </p>
        </div>

        <!-- <button
          type="submit"
          class="mt-8 flex flex-row justify-center w-60 m-auto text-white focus:outline-none focus:ring-notus-primary-300 font-medium rounded-3xl text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          (click)="sendUsername($event)"
          [class]="
            isLoading
              ? 'bg-white ring-notus-primary-700 ring-2 cursor-default'
              : 'bg-notus-primary-700 hover:bg-notus-primary-800'
          "
        >
          <ng-container *ngIf="!isLoading">
            <ng-container *ngIf="userInfo.email">{{ 'Send me an email' | translate }}</ng-container>
            <ng-container *ngIf="!userInfo.email && userInfo.mobilePhone">{{ 'Send me a SMS' | translate }}</ng-container>
          </ng-container>
          <ng-container *ngIf="isLoading">
            <flowbite-loading size="1.25rem"></flowbite-loading>
          </ng-container>
        </button> -->
      </ng-container>

      <div class="text-center mt-4">
        <div class="">
          <p
            class="my-4 text-sm font-light text-gray-800 dark:text-white text-center"
            [translate]="
              'If you are unable to provide the above information, please call {{contact}} for follow-up.'
            "
            [translateParams]="{ contact: supportNumber }"
            *ngIf="!(userInfo.email || userInfo.mobilePhone)"
          ></p>

          <p
            class="text-sm font-light text-gray-800 dark:text-gray-400 text-center"
          >
            <a
              (click)="goToLogin($event)"
              class="text-notus-primary-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
              >{{ 'Back to login' | translate }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</ciciam-frame-front>
